export default __webpack_public_path__ + "static/media/cupo.713c7dbb.svg";